import React from 'react';
import { Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { TextField } from '../../components/AtomComponents';

import { IInputsState } from './usePxwSelectionInputs';
import { IOptionsState } from './usePxwSelectionOptions';
import { IItem, IPurchaseOrder, ITestProvider } from '../../views/PxwProcessDevices/types';

interface IPxwDropdownSelectorsProps {
  selectedTenant: string | null;
  formInputs: IInputsState;
  formOptions: IOptionsState;
  onTestProviderChange: (_: any, value: ITestProvider | null) => void;
  onPOChange: (_: any, value: IPurchaseOrder | null) => void;
  onItemChange: (_: any, value: IItem | null) => void;
}

const PxwDropdownSelectors: React.FC<IPxwDropdownSelectorsProps> = ({
  formInputs,
  formOptions,
  selectedTenant,
  onTestProviderChange,
  onPOChange,
  onItemChange,
}) => (
  <div className="margin-top-1">
    <p className="text-faded">
      Select the test provider, purchase order, and SKU to generate test data for.
    </p>
    <div className="grid-x grid-margin-x grid-margin-y">
      <div className="cell small-12 medium-4">
        <Autocomplete
          options={formOptions.testProviders}
          value={formInputs.selectedTestProvider}
          disabled={!selectedTenant}
          getOptionLabel={(o) => o.testProviderName}
          onChange={onTestProviderChange}
          renderInput={(params) => (
            <TextField {...params} label="Select Test Provider" variant="outlined" />
          )}
        />
      </div>
      <div className="cell small-12 medium-4">
        <Autocomplete
          options={formOptions.purchaseOrders}
          value={formInputs.selectedPO}
          disabled={!formInputs.selectedTestProvider}
          getOptionLabel={(o) => o.purchaseOrderNumber}
          onChange={onPOChange}
          renderInput={(params) => <TextField {...params} label="Select PO" variant="outlined" />}
        />
      </div>
      <div className="cell small-12 medium-4">
        <Autocomplete
          options={formInputs.selectedPO?.items || []}
          value={formInputs.selectedItem}
          disabled={!formInputs.selectedPO}
          getOptionLabel={(o) => `${o.itemNumber} (Received: ${o.quantityInProcessingSourceBins})`}
          onChange={onItemChange}
          renderInput={(params) => <TextField {...params} label="Select SKU" variant="outlined" />}
        />
        <Typography
          style={{ height: '16px', display: 'inline-block' }}
          variant="caption"
          color="textSecondary">
          {formInputs.selectedItem
            ? `Received quantity: ${formInputs.selectedItem.quantityInProcessingSourceBins}`
            : ''}
        </Typography>
      </div>
    </div>
  </div>
);

export default PxwDropdownSelectors;
